import React, { useState } from "react";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForFiles] = useState("http://127.0.0.1:8000/storage");
  const [baseUrl, setBaseUrl] = useState(
    "https://crafthive.btsportfolio2026.com/backend/public/api",
  );
  const [baseUrlForFiles] = useState(
    "https://crafthive.btsportfolio2026.com/backend/public/storage",
  );
  // ── Separate auth tokens per role ──────────────────────────────
  const [customerAuthToken, setCustomerAuthToken] = useState(() => {
    return localStorage.getItem("customerAuthToken") || "";
  });
  const [sellerAuthToken, setSellerAuthToken] = useState(() => {
    return localStorage.getItem("sellerAuthToken") || "";
  });
  const [adminAuthToken, setAdminAuthToken] = useState(() => {
    return localStorage.getItem("adminAuthToken") || "";
  });

  const [selectedSellerTicket, setSelectedSellerTicket] = useState(null);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [selectedShop, setSelectedShop] = useState(() => {
    return JSON.parse(localStorage.getItem("selectedShop")) || null;
  });

  // ── selectedOrder: persisted to localStorage so it survives a page
  // refresh on the Order Details screen (same pattern as selectedShop) ──
  const [selectedOrder, setSelectedOrderState] = useState(() => {
    return JSON.parse(localStorage.getItem("selectedOrder")) || null;
  });

  const setSelectedOrder = (orderOrUpdater) => {
    setSelectedOrderState((prev) => {
      const newOrder =
        typeof orderOrUpdater === "function"
          ? orderOrUpdater(prev)
          : orderOrUpdater;

      if (newOrder) {
        localStorage.setItem("selectedOrder", JSON.stringify(newOrder));
      } else {
        localStorage.removeItem("selectedOrder");
      }

      return newOrder;
    });
  };

  const [sellerSelectedOrder, setSellerSelectedOrder] = useState(null);
  const [sellerSelectedReturn, setSellerSelectedReturn] = useState(null);
  const [adminSelectedOrder, setAdminSelectedOrder] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState("All Products");
  const [unreadCounts, setUnreadCounts] = useState(() => {
    const saved = localStorage.getItem("unreadCounts");
    const defaults = { cart: 0, favourites: 0, notifications: 0 };
    return saved ? { ...defaults, ...JSON.parse(saved) } : defaults;
  });

  const [seller, setSeller] = useState(() => {
    return JSON.parse(localStorage.getItem("loggedInSeller")) || null;
  });

  const incrementUnread = (key) => {
    setUnreadCounts((prev) => {
      const updated = { ...prev, [key]: (prev[key] || 0) + 1 };
      localStorage.setItem("unreadCounts", JSON.stringify(updated));
      return updated;
    });
  };
  const setUnreadCount = (key, value) => {
    setUnreadCounts((prev) => {
      const updated = { ...prev, [key]: value };
      localStorage.setItem("unreadCounts", JSON.stringify(updated));
      return updated;
    });
  };

  const clearUnread = (key) => {
    setUnreadCounts((prev) => {
      const updated = { ...prev, [key]: 0 };
      localStorage.setItem("unreadCounts", JSON.stringify(updated));
      return updated;
    });
  };

  const [selectedProductForCustomer, setSelectedProductForCustomer] =
    useState(null);

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!(
      localStorage.getItem("customerAuthToken") &&
      localStorage.getItem("loggedInCustomer")
    );
  });

  const [customer, setCustomer] = useState(() => {
    const savedCustomer = localStorage.getItem("loggedInCustomer");
    return savedCustomer ? JSON.parse(savedCustomer) : null;
  });
  const [admin, setAdmin] = useState(() => {
    return JSON.parse(localStorage.getItem("loggedInAdmin")) || null;
  });


  const setCustomerToken = (token) => {
    setCustomerAuthToken(token);
    if (token) localStorage.setItem("customerAuthToken", token);
    else localStorage.removeItem("customerAuthToken");
  };

  const setSellerToken = (token) => {
    setSellerAuthToken(token);
    if (token) localStorage.setItem("sellerAuthToken", token);
    else localStorage.removeItem("sellerAuthToken");
  };

  const setAdminToken = (token) => {
    setAdminAuthToken(token);
    if (token) localStorage.setItem("adminAuthToken", token);
    else localStorage.removeItem("adminAuthToken");
  };


  const logout = () => {
  setCustomer(null);
  setIsAuthenticated(false);
  setCustomerToken("");
  localStorage.removeItem("loggedInCustomer");
  localStorage.removeItem("unreadCounts");
  localStorage.removeItem("selectedShop");
  setSelectedShop(null);
  setSelectedOrder(null);
  setSelectedProductForCustomer(null);
  setSelectedConversation(null);
};



  const usernameRegex = new RegExp(/^[A-Za-z0-9]{5,35}$/);
  const emailRegExp = new RegExp(
    /^[A-Za-z0-9]{5,}@[a-z0-9]{3,}\.[a-z0-9.]{2,}$/,
  );
  const passwordRegExp = new RegExp(/^[A-Za-z0-9@.$*?&_#!-]{8,}$/);

  const regExpChecker = (type, inp) => {
    switch (type) {
      case "username":
        if (!usernameRegex.test(inp)) {
          return "Username must be 5-20 characters, letters and numbers only";
        }
        break;
      case "email":
        if (!emailRegExp.test(inp)) {
          return "Please enter a valid email address";
        }
        break;
      case "password":
        if (!passwordRegExp.test(inp)) {
          return "Password must be at least 8 characters";
        }
        break;
      case "confirmPassword":
        if (inp.password !== inp.confirmPassword) {
          return "Passwords do not match";
        }
        break;
      case "required":
        if (!inp || inp.toString().trim() === "") {
          return "This field is required";
        }
        break;
    }
    return "";
  };

  const validateForm = (fields) => {
    for (let i = 0; i < fields.length; i++) {
      let fieldName = fields[i][0];
      let fieldValue = fields[i][1];

      if (!fieldValue || fieldValue.toString().trim() === "") {
        return fieldName + " is required";
      }
    }
    return "";
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        baseUrlForFiles,
        isAuthenticated,

        // customer
        customerAuthToken,
        setCustomerToken,
        selectedProductForCustomer,
        setSelectedProductForCustomer,
        selectedOrder,
        setSelectedOrder,
        customer,
        setCustomer,
        logout,

        // admin
        adminAuthToken,
        setAdminToken,
        admin,
        setAdmin,


        // seller
        sellerAuthToken,
        setSellerToken,
        seller,
        setSeller,

        unreadCounts,
        incrementUnread,
        setUnreadCount,
        clearUnread,
        setIsAuthenticated,
        selectedShop,
        setSelectedShop,
        regExpChecker,
        validateForm,
        selectedConversation,
        setSelectedConversation,
        selectedSellerTicket,
        setSelectedSellerTicket,
        sellerSelectedOrder,
        setSellerSelectedOrder,
        sellerSelectedReturn,
        setSellerSelectedReturn,
        adminSelectedOrder, 
        setAdminSelectedOrder,
        selectedCategory,
        setSelectedCategory,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;